export enum FilterSectionEnum {
    CONTENT = 'CONTENT',
    LOCATION = 'LOCATION',
    ANALYSIS = 'ANALYSIS',
    CONTACT_DETAIL = 'CONTACT_DETAIL',
    OUTLET_DETAIL = 'OUTLET_DETAIL',
    CONTACT_OUTLET_DETAIL = 'CONTACT_OUTLET_DETAIL',
    COVERAGE_PROFILE = 'COVERAGE_PROFILE',
    ORGANIZATION = 'ORGANIZATION'
}
